$(window).load(function () {
  var conf = {
    before_label: '',
    // Set a custom before label
    after_label: '', // Set a custom after label
  };

  $('.twentytwenty-container-desktop').twentytwenty(conf);
});
